<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>User Limit Configuration for <strong>{{ decodeURI(value.user_info.name) }}</strong></h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">User Limit Configuration</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="configuration">
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header">
              <div class="card-tools">

              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-12">
                  <div class="offset-0 col-12">
                    <h4 class="site-heading my-3"><span>User Configuration</span></h4>
                    <div class="form-group required">
                      <label class="control-label">Max Balance</label>
                      <input type="hidden" id="user_id" name="user_id" v-model="value.user_id">
                      <input type="hidden" id="user_config_id" name="user_config_id" v-model="value.user_configs.id">
                      <input type="text" id="max_balance" name="max_balance"
                             v-bind:class="{'has-error' : errors.has('max_balance')}"
                             v-validate="'required|integer|min:1'"
                             v-model="value.user_configs.max_balance" class="form-control max_balance"
                             placeholder="Max Balance">
                      <div class="help text-danger" v-show="errors.has('max_balance')">
                        {{ errors.first("max_balance") }}
                      </div>
                    </div>
                  </div>

                  <div class="offset-0 col-12">
                    <h4 class="site-heading my-3"><span>User Activity Limits Configurations</span></h4>
                    <div class="form-row align-items-end" v-for="(item, i) in value.user_activity_limits" :key="i">
                      <div class="col-md-12">
                        <div class="row">
                          <input type="hidden" id="item.id" name="item.id" v-model="item.id">
                          <input type="hidden" id="item.activity_type_id" name="item.activity_type_id"
                                 v-model="item.activity_type_id">
                          <div class="col">
                            <div class="form-group col-md-12">
                              <label class="control-label">Activity Type</label>
                              <input type="text" readonly name="item.trx_activity_type" v-model="item.trx_activity_type"
                                     class="form-control"
                                     placeholder="Activity Type">
                            </div>
                          </div>

                          <div class="col">
                            <div class="form-group col-md-12 required">
                              <label class="control-label">Per Trx Min Amount</label>
                              <input type="text" id="per_trx_min_amount" name="per_trx_min_amount"
                                     v-model="item.per_trx_min_amount"
                                     v-bind:class="{'has-error' : errors.has('per_trx_min_amount')}"
                                     v-validate="'required|integer|min:1'"
                                     class="form-control per_trx_min_amount" placeholder="Per Trx Min Amount">
                              <div class="help text-danger" v-show="errors.has('per_trx_min_amount')">
                                {{ errors.first("per_trx_min_amount") }}
                              </div>
                            </div>
                          </div>

                          <div class="col">
                            <div class="form-group col-md-12 required">
                              <label class="control-label">Per Trx Max Amount</label>
                              <input type="text" name="per_trx_max_amount" v-model="item.per_trx_max_amount"
                                     v-bind:class="{'has-error' : errors.has('per_trx_max_amount')}"
                                     v-validate="'required|integer|min:1'"
                                     class="form-control per_trx_max_amount" placeholder="Per Trx Max Amount">
                              <div class="help text-danger" v-show="errors.has('per_trx_max_amount')">
                                {{ errors.first("per_trx_max_amount") }}
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>

                    </div>
                  </div>

                  <div class="offset-0 col-12">
                    <h4 class="site-heading my-3"><span>User Limits Configurations</span></h4>
                    <div class="form-row align-items-end" v-for="(item, i) in value.user_limit_configs" :key="i">
                      <div class="col-md-12">
                        <div class="row">
                          <input type="hidden" id="item.id" name="item.id" v-model="item.id">
                          <div class="col">
                            <div class="form-group col-md-12">
                              <label class="control-label">Activity Type</label>
                              <input type="text" readonly disabled name="item.trx_activity_type"
                                     v-model="item.trx_activity_type"
                                     class="form-control"
                                     placeholder="Activity Type">
                            </div>
                          </div>

                          <div class="col">
                            <div class="form-group col-md-12">
                              <label class="control-label">Frequency</label>
                              <input type="text" readonly disabled name="item.frequency" v-model="item.frequency"
                                     class="form-control" placeholder="Frequency">
                            </div>
                          </div>

                          <div class="col">
                            <div class="form-group col-md-12">
                              <label class="control-label">Consumed Amount</label>
                              <input type="text" readonly disabled name="item.total_trx_amount"
                                     v-model="item.total_trx_amount"
                                     class="form-control" placeholder="Consumed Amount">
                            </div>
                          </div>


                          <div class="col">
                            <div class="form-group col-md-12">
                              <label class="control-label">Consumed Count</label>
                              <input type="text" readonly disabled name="item.total_trx_count"
                                     v-model="item.total_trx_count"
                                     class="form-control item.total_trx_count" placeholder="Consumed Count">
                            </div>
                          </div>

                          <div class="col">
                            <div class="form-group col-md-12 required">
                              <label class="control-label">Max Trx Count</label>
                              <input type="text" name="max_trx_count" v-model="item.max_trx_count"
                                     v-bind:class="{'has-error' : errors.has('max_trx_count')}"
                                     v-validate="'required|integer|min:1'"
                                     class="form-control max_trx_count" placeholder="Max Trx Count">
                              <div class="help text-danger" v-show="errors.has('max_trx_count')">
                                {{ errors.first("max_trx_count") }}
                              </div>
                            </div>
                          </div>

                          <div class="col">
                            <div class="form-group col-md-12 required">
                              <label class="control-label">Max Trx Amount</label>
                              <input type="text" name="max_trx_amount" v-model="item.max_trx_amount"
                                     v-bind:class="{'has-error' : errors.has('max_trx_amount')}"
                                     v-validate="'required|integer|min:1'"
                                     class="form-control max_trx_amount" placeholder="Max Trx Amount">
                              <div class="help text-danger" v-show="errors.has('max_trx_amount')">
                                {{ errors.first("max_trx_amount") }}
                              </div>
                            </div>
                          </div>


                        </div>
                      </div>

                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="card-footer">
              <button type="submit" class="btn btn-primary">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

//import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import {DepartmentsAPI, CommonAPI} from '@/services/api'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import axios from 'axios'

export default {
  name: 'UserLimitUpdateConfig',
  metaInfo: {
    title: 'User Limits Configurations | Dotlines'
  },
  components: {
    DatePicker
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    value: {},
    pre: {}
  }),
  methods: {

    handleSubmission() {
      let _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true
          let api_url = '/update-user-config'
          axios({
            method: 'PUT',
            url: api_url,
            data: {
              payload: _this.value
            },
            headers: {'Content-Type': 'application/json'},
          }).then(function (response) {
            _this.$toaster.success(response.data.message)
            _this.is_loading = false
          }).catch((errors) => {
            /*console.log("Error", errors.response.data.errors.message)
            this.$toaster.error(errors.response.data.errors.message)*/
            if (errors.response.status === 500) {
              _this.$toaster.error(errors.response.data.message)
            }
            _this.$setErrorsFromResponse(errors.response.data)
          }).finally(() => {
            _this.is_loading = false
          });
        }
      });
    },
    getConfiguration: function (params) {
      return new Promise((resolve, reject) => {
        let api_url = '/get-user-config/' + params.id
        axios.get(api_url)
          .then(response => {
            resolve(response)
          })
          .catch((error) => {
            //console.error('error ' + error)
            reject(error)
          });
      });
    },
    async initialize() {
      this.is_loading = true
      this.params = this.$route.params
      await this.getConfiguration(this.params).then(response => {
        this.value = response.data
      }).catch((error) => {
        console.log(error.response)
      })
      this.is_loading = false
    }
  },
  mounted() {
    this.initialize()
  },

}
</script>

